export function getDeckRoute(user: string, deckId: string): string {
    var path = `/user/${user}/decks/${deckId}`;
    return path;
}